import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title?: string;
  description?: string;
  image?: string;
  url?: string;
  type?: string;
}

const SEO: React.FC<SEOProps> = ({
  title = 'DriftRealm - Your Memory Sanctuary',
  description = 'Explore and share your dreams in an interactive constellation map. Connect with others through shared dream experiences and discover patterns in your subconscious mind.',
  image = '/og-image.jpg',
  url = '',
  type = 'website'
}) => {
  // Use window.location.origin for development, fallback to production URL
  const siteUrl = window.location.origin || 'https://driftrealm.com';
  const fullUrl = `${siteUrl}${url}`;
  const fullImage = `${siteUrl}${image}`;

  return (
    <Helmet>
      {/* Google Site Verification */}
      <meta name="google-site-verification" content="MBlwcxPsUtIviEnYOqu3w4i_i31xzkWoIGVwDCprHMY" />

      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImage} />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={fullUrl} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={fullImage} />

      {/* Canonical URL */}
      <link rel="canonical" href={fullUrl} />
    </Helmet>
  );
};

export default SEO; 